// Re-export all table utilities from their respective modules

// Constants and default configurations
export {
  DEFAULT_BREAKPOINT_WIDTH,
  createDefaultColumnConfig,
  createDefaultRowConfig,
  createDefaultCellConfig,
  TABLE_SETTINGS_KEYS,
  BREAKPOINT_WIDTH_KEYS,
  COLUMN_SETTINGS_KEYS,
  ROW_SETTINGS_KEYS,
} from "./tableConstants";

// Serialization utilities (compact/expand)
export {
  compactTableSettings,
  expandTableSettings,
  compactColumnSettings,
  expandColumnSettings,
} from "./tableSerializer";

// Default stripping utilities
export {
  stripDefaultBreakpointWidth,
  stripBreakpointWidthAgainstBase,
  stripDefaultTableSettings,
  stripDefaultColumnConfig,
  stripDefaultRowConfig,
  stripDefaultCellConfig,
} from "./tableDefaults";

// DOM utilities
export {
  getCurrentColumnIndex,
  getTotalColumns,
  getCurrentRowIndex,
  getTotalRows,
  readColumnSettingsFromDOM,
  findSelectedCellIndices,
  cleanupTableWrappers,
  ensureOtherTablesHaveWrappers,
  ensureAllTablesHaveWrappers,
  cleanupTableStyles,
  createTableWrapper,
} from "./tableDomUtils";

// CSS generation utilities
export {
  generateColumnCSS,
  generateColumnClassCSS,
  generateColumnIndexCSS,
  generateTableClassCSS,
  generateTableCSS,
  generateCellClassCSS,
  generateCellCSS,
  generateRowCSS,
} from "./tableCssGenerator";

// HTML cleanup utilities
export {
  removeStyleTags,
  cleanupHTMLForOutput,
  extractNonTableStyleTags,
} from "./tableHtmlUtils";
